import React from 'react';
import { get } from 'utils/LocalStorageUtil';
import { useProfiles } from 'containers/ProfileManager/hooks/useProfiles';
import { ProfileManager } from 'containers/ProfileManager';
import PinForm from 'containers/PinForm';
import { useSelector } from 'react-redux';
import { useLocation } from 'react-router-dom';
import { useLoginFromMobile } from 'hooks/useLoginFromMobile';
import ModalPassword from 'containers/ForgottenPassword/components/ModalPassword';
import StartupMetrics from 'containers/StartupMetrics';

const ProfileProvider = ({ children }) => {
  const location = useLocation();
  const isPayment = location?.pathname?.includes('payment');
  const path = location?.pathname !== '/';
  const hasSelectedProfile = get('selectProfile');
  const { profilesEnable, hasChecked } = useProfiles();
  const user = useSelector(state => state.user) || {};
  const { isMyAccountFromMobile } = useLoginFromMobile();
  const isInPlayer =
    location.pathname?.includes('watch') ||
    location.search?.includes('anonymousUserComeFromPlayer');
  const isSetControlpin = location.pathname?.includes('setcontrolpin');
  const { modalVisibility } = useSelector(state => state.resetPassword);
  const isForgettenPassword = window.location.pathname?.includes(
    'forgottenPassword',
  );

  if (!hasChecked) return <></>;
  if (
    isForgettenPassword ||
    modalVisibility ||
    sessionStorage.getItem('changePasswordModal')
  )
    return <>{children}</>;
  if (
    profilesEnable &&
    path &&
    !hasSelectedProfile &&
    user.acceptTerms === 1 &&
    !isPayment &&
    !isMyAccountFromMobile &&
    !isInPlayer &&
    !isSetControlpin
  )
    return (
      <>
        <ProfileManager />
        <StartupMetrics />
        <PinForm />
      </>
    );
  return (
    <>
      <StartupMetrics />
      {children}
    </>
  );
};
export default ProfileProvider;
